import request from '@/plugin/axios';
export function AccountLogin(data) {
  return request({
    url: '/admin/index/doLogin',
    method: 'post',
    data: data
  });
}